import { ReduxStateType } from '../types';

export const getServicesRequiringProofingSelector = (state: ReduxStateType) => {
	return state?.actionItems?.servicesRequiringProofing ?? [];
};

export const getPendingScheduleRequestsSelector = (state: ReduxStateType) => {
	return state?.actionItems?.scheduleRequests ?? [];
};
